import React, { useState, useEffect, useMemo } from "react";
import {
  pdf,
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  PDFViewer,
  Font,
} from "@react-pdf/renderer";
import EditarCotizacionForm from "./EditarCotizacionForm";
import { deleteDoc, getDoc, doc, updateDoc } from "firebase/firestore";
import { db, storage } from "../firebaseConfig";
import { ref, deleteObject } from "firebase/storage";
import Modal from "react-modal";
import Swal from "sweetalert2";
import OpenRegular from "../fonts/OpenSans-Regular.ttf";
import OpenBold from "../fonts/OpenSans-Bold.ttf";
import { useNavigate } from "react-router-dom";
import { useFunctionsPrevia } from "../hooks/useFunctionsPrevia";

Font.register({
  family: "Open",
  fonts: [
    { src: OpenRegular, fontWeight: "normal" },
    { src: OpenBold, fontWeight: "bold" },
  ],
});

const styles = StyleSheet.create({
  pdfContainer: {
    position: "fixed",
    inset: 0,
    padding: "2vw",
    backgroundColor: "rgba(0,0,0,0.6)",
    zIndex: 1000,
    display: "grid",
    placeItems: "center",
  },
  pdfViewer: {
    width: "min(96vw, 1200px)",
    height: "min(94dvh, 1000px)",
    border: "1px solid #ccc",
    borderRadius: 8,
    overflow: "hidden",
    backgroundColor: "#fff",
    boxShadow: "0 10px 30px rgba(0,0,0,.25)",
  },
  page: {
    paddingTop: 30,
    paddingRight: 30,
    paddingLeft: 30,
    paddingBottom: 30,
    position: "relative",
  },

  /* ===== Encabezado nuevo ===== */
  headerRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 6,
    marginBottom: 10,
  },
  brandLeft: { width: "55%" },
  brandLogo: { width: 140 },
  brandTag: { fontFamily: "Open", fontSize: 10, color: "#555", marginTop: 2 },

  rightHeader: {
    width: "45%",
    alignItems: "flex-end",
    justifyContent: "center",
  },
  titleCotizacion: {
    fontFamily: "Open",
    fontSize: 26,
    fontWeight: "bold",
    color: "#1e88e5",
    letterSpacing: 1.6,
  },
  folioBadge: {
    marginTop: 10,
    backgroundColor: "#e53935",
    paddingVertical: 6,
    paddingHorizontal: 12,
    borderRadius: 4,
  },
  folioText: {
    fontFamily: "Open",
    fontSize: 14,
    fontWeight: "bold",
    color: "#fff",
    letterSpacing: 1.5,
  },
  topDividerBlue: {
    height: 2,
    backgroundColor: "#1e88e5",
    marginTop: 8,
    marginBottom: 14,
    width: "100%",
  },

  clientBlock: { marginTop: 6, marginBottom: 8 },
  clientLine: { fontFamily: "Open", fontSize: 10, marginBottom: 2 },
  clientLabel: { fontFamily: "Open", fontSize: 10, fontWeight: "bold" },
  clientValue: { fontFamily: "Open", fontSize: 10 },
  clientValueBlue: { fontFamily: "Open", fontSize: 10, color: "#1e88e5" },

  /* ===== Tarjetas grises ===== */
  metaRow: { flexDirection: "row", marginTop: 8 },
  metaCell: {
    flexGrow: 1,
    flexBasis: 0,
    backgroundColor: "#eee",
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 12,
    paddingRight: 12,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 48,
  },
  metaCellWithDivider: { borderLeftWidth: 3, borderLeftColor: "#fff" },
  metaLabel: {
    fontFamily: "Open",
    fontSize: 9,
    color: "#333",
    marginBottom: 4,
    textAlign: "center",
  },
  metaValue: {
    fontFamily: "Open",
    fontSize: 10,
    fontWeight: "bold",
    textAlign: "center",
  },

  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: "20px",
    marginTop: "20px",
  },
  logoContainer: { width: "50%", marginTop: "5px" },
  logo: { width: "150px", height: "auto" },
  headerInfo: { width: "50%", textAlign: "right" },
  companyName: { fontSize: "10px", fontWeight: 600, fontFamily: "Open" },
  companyDetails: { fontSize: "10px", fontFamily: "Open", marginTop: "2px" },
  titleSection: { textAlign: "center", marginBottom: "20px" },
  title: { fontSize: "18px", fontWeight: "bold", color: "#1976d2" },
  infoContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: "20px",
  },
  clientInfo: { width: "50%", fontSize: "10px" },
  infoTitle: { fontSize: "10px", fontFamily: "Open", marginBottom: "5px" },
  infoText: { fontSize: "10px", fontFamily: "Open", marginBottom: "3px" },
  infoTextColor: {
    fontSize: "10px",
    fontFamily: "Open",
    marginBottom: "3px",
    color: "#1976d2",
    fontWeight: 600,
  },
  infoBlessed: {
    fontSize: "11px",
    marginTop: "10px",
    fontFamily: "Open",
    textAlign: "left",
    marginBottom: "10px",
  },
  cotizacionTable: {
    width: "50%",
    textAlign: "right",
    marginTop: "-10px",
    left: "40px",
  },

  /* ===== TABLA (PDF) ===== */
  table: {
    marginTop: 10,
    marginBottom: 10,
    fontFamily: "Open",
    width: "100%",
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderColor: "#fff",
    backgroundColor: "#F9F9F9",
  },

  /* HEADER con celdas <View> para que los bordes sean de alto completo */
  tableRowHeader: {
    flexDirection: "row",
    backgroundColor: "#6c6c6c",
    alignItems: "stretch",
    minHeight: 30,
  },
  thCell: {
    justifyContent: "center",
    paddingVertical: 8,
    paddingHorizontal: 10,
    borderRightWidth: 2,
    borderRightColor: "#ffffff",
  },
  thText: {
    fontSize: 9,
    textAlign: "center",
    color: "#fff",
    fontFamily: "Open",
  },

  // (legacy) usadas en otras vistas
  tableCell: {
    padding: 8,
    textAlign: "left",
    borderRightWidth: 1,
    borderRightColor: "#fff",
    borderRightStyle: "solid",
    fontSize: "11px",
    lineHeight: "1.5",
  },
  tableCellDesc: {
    padding: 8,
    textAlign: "left",
    borderRightWidth: 1,
    borderRightColor: "#fff",
    borderRightStyle: "solid",
    fontSize: "10px",
    lineHeight: "1.5",
    color: "#7E7D7D",
  },

  // CUERPO
  tr: {
    flexDirection: "row",
    backgroundColor: "#f3f5f6",
    borderBottomWidth: 2,
    borderBottomColor: "#ffffff",
    alignItems: "stretch",
  },
  trAlt: { backgroundColor: "#eef1f2" },

  td: {
    fontSize: 10.5,
    paddingVertical: 10,
    paddingHorizontal: 10,
    borderRightWidth: 2,
    borderRightColor: "#ffffff",
    minHeight: 28,
  },
  tdDesc: {
    paddingVertical: 10,
    paddingHorizontal: 12,
    borderRightWidth: 2,
    borderRightColor: "#ffffff",
    flexDirection: "column",
  },

  // Columnas (proporciones)
  colNum: { flex: 0.6 },
  colDesc: { flex: 6.2 },
  colModel: { flex: 1.4 },
  colQty: { flex: 0.8 },
  colPrice: { flex: 1.2 },
  colSub: { flex: 1.4 },

  // Alineaciones rápidas
  center: { textAlign: "center" },
  right: { textAlign: "right" },

  // Quita el borde derecho en la última columna (SUBTOTAL)
  lastCol: { borderRightWidth: 0 },

  closeButton: { color: "#fff", top: "15px", fontSize: "20px" },

  tableSmall: {
    marginTop: "10px",
    width: "30%",
    alignSelf: "flex-end",
    marginRight: "-20px",
  },
  tableRowSmall: {
    display: "flex",
    flexDirection: "row",
    marginBottom: "3px",
    alignItems: "stretch",
  },
  tableLabelSmall: {
    fontSize: "9px",
    fontWeight: "bold",
    width: "30%",
    padding: "6px",
    color: "#fff",
    backgroundColor: "#6c6c6c",
    textAlign: "left",
  },
  tableValueSmall: {
    fontSize: "9px",
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: "70%",
    textAlign: "left",
    width: "70%",
    padding: 6,
    paddingRight: 12,
    margin: 0,
    lineHeight: 1.35,
  },

  footerContainer: {
    marginTop: 10,
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    alignItems: "flex-start",
    minHeight: 0,
  },
  footerLeft: { width: "45%", textAlign: "justify", left: 0 },
  footerRight: { width: "40%", textAlign: "right", alignSelf: "flex-end" },
  footerRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  footerRowGray: { backgroundColor: "#F9F9F9", padding: 8 },
  footerRowBlue: { backgroundColor: "#1565c0", padding: 8 },
  footerLabel: { fontSize: 11, textAlign: "right" },
  footerValue: { fontSize: 11, textAlign: "right" },
  footerLabelBlue: { color: "#fff", fontWeight: "bold" },
  footerValueBlue: { color: "#fff", fontWeight: "bold", margin: 0 },

  // contenedores añadidos para alinear totales
  footerLabelContainer: { flexGrow: 1 },
  footerValueContainer: { minWidth: 120, alignItems: "flex-end" },

  condicionesTitle: {
    fontSize: "10px",
    marginBottom: 15,
    marginTop: 10,
    fontFamily: "Open",
  },
  termsContainer: { gap: 10, textAlign: "justify", fontFamily: "Open" },
  numeroDePagina: { color: "#999999", fontSize: 12 },

  condicionesContainer: {
    marginBottom: 10,
    padding: 10,
    borderWidth: 1,
    borderColor: "#000",
  },
  condicionesTitulo: {
    fontSize: 12,
    fontWeight: 600,
    color: "red",
    marginBottom: 5,
    fontFamily: "Open",
  },
  condicionesTexto: {
    fontSize: 11,
    marginBottom: 3,
    fontFamily: "Open",
    textAlign: "justify",
  },
  condicionesTexto2: {
    fontSize: 11,
    marginBottom: 3,
    fontFamily: "Open",
    textAlign: "justify",
  },
  espaciado: { marginBottom: 20 },

  cancelacionesContainer: {
    marginBottom: 10,
    padding: 10,
    borderWidth: 1,
    borderColor: "#000",
  },
  cancelacionesTitulo: {
    fontFamily: "Open",
    fontSize: 12,
    fontWeight: "bold",
    color: "red",
    marginBottom: 5,
    marginTop: 15,
  },
  cancelacionesTexto: {
    fontSize: 11,
    marginBottom: 5,
    textAlign: "justify",
    fontFamily: "Open",
  },

  garantiaContainer: {
    marginBottom: 10,
    padding: 10,
    borderWidth: 1,
    borderColor: "#000",
  },
  garantiaTexto: {
    fontSize: 11,
    textAlign: "justify",
    marginBottom: 3,
    fontFamily: "Open",
  },

  bancariosContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "stretch",
    padding: 10,
    borderWidth: 1,
    margin: 0,
    borderColor: "#000",
    height: 120,
  },
  datosBancariosIzquierda: { width: "48%", gap: 5 },
  datosBancariosDerecha: { width: "48%", textAlign: "left" },
  lineaDivisoria: {
    width: 1,
    backgroundColor: "#000",
    height: "119px",
    top: -10,
  },
  datosBancariosTitulo: {
    fontSize: 12,
    fontWeight: "bold",
    fontFamily: "Open",
    marginBottom: 5,
  },
  banco: { fontSize: 11, fontFamily: "Open", marginBottom: 3 },
  moneda: { fontSize: 11, marginBottom: 3, fontFamily: "Open" },
  beneficiario: { fontSize: 11, fontFamily: "Open", marginBottom: 3 },
  cuenta: { fontSize: 11, fontFamily: "Open", marginBottom: 3 },
  clabe: { fontSize: 11, fontFamily: "Open", marginBottom: 3 },
  referencias: {
    fontSize: 11,
    color: "red",
    marginBottom: 5,
    fontFamily: "Open",
  },
  envioComprobante: {
    fontSize: 11,
    color: "red",
    fontFamily: "Open",
    marginBottom: 3,
  },
  correos: { fontSize: 11, marginBottom: 2, fontFamily: "Open" },

  footerBlock: { marginTop: 10, width: "100%" },
  montoEnLetrasLabel: {
    fontFamily: "Open",
    fontWeight: "bold",
    fontSize: 9,
    textAlign: "right",
    paddingRight: 5,
    marginTop: 4,
    color: "#666",
  },
  montoEnLetras: {
    fontFamily: "Open",
    fontWeight: "bold",
    fontSize: 9,
    marginTop: 0,
    textAlign: "right",
    paddingRight: 5,
  },

  tableLabelBox: {
    width: "30%",
    backgroundColor: "#6c6c6c",
    padding: 6,
    justifyContent: "center",
  },
  tableLabelSmallText: {
    fontSize: 9,
    fontWeight: "bold",
    color: "#fff",
    textAlign: "left",
  },

  rowTight: { marginBottom: 3 },
  labelTightBoxSm: { paddingTop: 2, paddingBottom: 2 },
  valueTightSm: { paddingTop: 2, paddingBottom: 3, lineHeight: 1.2 },

  montoGroup: { alignItems: "flex-end", marginTop: 22, paddingRight: 5 },

  // === Ajustados para el nuevo layout de descripción ===
  descTitle: {
    fontSize: 9,
    color: "#000",
    fontWeight: "bold",
    textTransform: "uppercase",
    marginBottom: 3,
  },
  descExtra: {
    fontSize: 10,
    color: "#404040",
    lineHeight: 1.35,
  },

  cellTop: { alignSelf: "flex-start" },

  /* ==== NUEVOS ESTILOS PARA EL BLOQUE POSTERIOR AL TOTAL ==== */
  sectionBlock: { marginTop: 16, fontFamily: "Open" },
  sectionTitle: { fontSize: 12, fontWeight: "bold", marginBottom: 8 },
  paragraph: {
    fontSize: 11,
    lineHeight: 1.35,
    textAlign: "justify",
    marginBottom: 14,
  },
  sectionHeading: {
    fontSize: 11,
    fontWeight: "bold",
    marginTop: 12,
    marginBottom: 6,
  },
  sectionItem: { fontSize: 11, marginBottom: 4 },
  /* ===== Hoja final (condiciones) – tipografía más chica ===== */
  legalSection: { marginTop: 12, fontFamily: "Open" },
  legalTitle: { fontSize: 10, fontWeight: "bold", marginBottom: 6 },
  legalHeading: {
    fontSize: 9.5,
    fontWeight: "bold",
    marginTop: 10,
    marginBottom: 4,
  },
  legalParagraph: {
    fontSize: 9,
    lineHeight: 1.24,
    textAlign: "justify",
    marginBottom: 10,
  },
  legalItem: { fontSize: 9, marginBottom: 3 },
  /* ===== NUEVOS ESTILOS: bloque de dirección (derecha, más abajo) ===== */
  addressBlock: {
    width: "60%",
    alignSelf: "flex-end",
    marginTop: 12,
  },
  addressCompany: {
    fontSize: 9,
    fontWeight: "bold",
    textAlign: "left",
    fontFamily: "Open",
    marginBottom: 2,
  },
  addressLine: {
    fontSize: 9,
    textAlign: "left",
    fontFamily: "Open",
    marginBottom: 2,
  },
  addressFixed: {
    position: "absolute",
    left: 30,
    bottom: 42,
    width: "58%",
    alignItems: "flex-start",
    fontSize: 9,
  },
  // dirección en el header (arriba, a la derecha del logo)
  headerAddress: { width: "45%", alignItems: "flex-end" },
  headerCompany: { fontFamily: "Open", fontSize: 9, fontWeight: "bold" },
  headerAddressLine: { fontFamily: "Open", fontSize: 9, marginTop: 2 },
  clientAndFolioRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 6,
    marginBottom: 6,
  },
  folioRightInline: {
    width: "42%",
    alignItems: "flex-end",
    justifyContent: "center",
    minHeight: 62,
    alignSelf: "flex-start",
    marginTop: -3,
  },
});

// Estilos inline para el botón (DOM, no PDF)
const backBtnStyle = {
  position: "absolute",
  top: 0,
  right: 12,
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  padding: "8px 12px",
  fontFamily: "inherit",
  fontSize: 14,
  fontWeight: 600,
  color: "#111", // texto negro
  background: "#f1f3f5",
  border: "1px solid #d0d7de",
  borderRadius: 8,
  cursor: "pointer",
  boxShadow: "0 1px 0 rgba(0,0,0,.04)",
  lineHeight: 1,
};

const backBtnIconStyle = { fontSize: 20, lineHeight: 0 };

/* ===== Helpers números → letras ===== */
const numeroATexto = (n) => {
  n = Math.floor(Math.abs(n));
  if (n === 0) return "CERO";
  const U = [
    "",
    "UNO",
    "DOS",
    "TRES",
    "CUATRO",
    "CINCO",
    "SEIS",
    "SIETE",
    "OCHO",
    "NUEVE",
  ];
  const E = {
    10: "DIEZ",
    11: "ONCE",
    12: "DOCE",
    13: "TRECE",
    14: "CATORCE",
    15: "QUINCE",
    16: "DIECISÉIS",
    17: "DIECISIETE",
    18: "DIECIOCHO",
    19: "DIECINUEVE",
  };
  const D = {
    20: "VEINTE",
    30: "TREINTA",
    40: "CUARENTA",
    50: "CINCUENTA",
    60: "SESENTA",
    70: "SETENTA",
    80: "OCHENTA",
    90: "NOVENTA",
  };
  const C = {
    100: "CIENTO",
    200: "DOSCIENTOS",
    300: "TRESCIENTOS",
    400: "CUATROCIENTOS",
    500: "QUINIENTOS",
    600: "SEISCIENTOS",
    700: "SETECIENTOS",
    800: "OCHOCIENTOS",
    900: "NOVECIENTOS",
  };
  const tens = (x) => {
    if (x < 10) return U[x];
    if (x <= 19) return E[x];
    if (x === 20) return "VEINTE";
    if (x < 30) {
      if (x === 22) return "VEINTIDÓS";
      if (x === 23) return "VEINTITRÉS";
      if (x === 26) return "VEINTISÉIS";
      return "VEINTI" + U[x - 20];
    }
    const de = Math.floor(x / 10) * 10;
    const un = x % 10;
    return D[de] + (un ? " Y " + U[un] : "");
  };
  const hundreds = (x) => {
    if (x === 100) return "CIEN";
    const h = Math.floor(x / 100) * 100;
    if (h) return C[h] + (x % 100 ? " " + tens(x % 100) : "");
    return tens(x);
  };
  let s = "";
  if (n >= 1_000_000) {
    const m = Math.floor(n / 1_000_000);
    s += m === 1 ? "UN MILLÓN" : `${numeroATexto(m)} MILLONES`;
    n %= 1_000_000;
    if (n) s += " ";
  }
  if (n >= 1000) {
    const k = Math.floor(n / 1000);
    s += k === 1 ? "MIL" : `${hundreds(k)} MIL`;
    n %= 1000;
    if (n) s += " ";
  }
  if (n > 0) s += hundreds(n);
  return s.trim();
};

const montoALetras = (monto, moneda = "PESOS", sufijo = "MXN") => {
  const totalCents = Math.round(Math.abs(monto) * 100);
  const entero = Math.floor(totalCents / 100);
  const cent = totalCents % 100;
  const fraccion = String(cent).padStart(2, "0");
  let literal = numeroATexto(entero);
  literal = literal.replace(/ UNO$/, " UN").replace(/ VEINTIUNO$/, " VEINTIÚN");
  literal = literal
    .replace(/ VEINTIUNO (?=MIL\b)/g, " VEINTIÚN ")
    .replace(/ UNO (?=MIL\b)/g, " UN ");
  const mon = moneda.toUpperCase();
  const monedaSingular =
    mon === "PESOS"
      ? "PESO"
      : mon === "DÓLARES" || mon === "DOLARES"
      ? "DÓLAR"
      : moneda;
  const usaDe = entero > 0 && entero % 1_000_000 === 0;
  const monedaFinal = entero === 1 ? monedaSingular : moneda;
  const monedaConDe = usaDe ? `DE ${monedaFinal}` : monedaFinal;
  return `${literal} ${monedaConDe} ${fraccion}/100 ${sufijo}`;
};

/* ===== Cliente por ID exacto de la cotización ===== */
const getClienteDeCotizacion = (cot, clientes) => {
  if (!cot) return null;
  const id = cot.cliente || cot.clienteId;
  if (!id) return null;
  return (clientes || []).find((c) => c.id === id || c.__docId === id) || null;
};

/* ===== Normalizadores para dirección ===== */
const clean = (v) => {
  if (v === null || v === undefined) return "";
  const s = String(v).trim();
  if (!s) return "";
  const basura = /^(n\/a|na|n\.?d\.?|\.|-|s\/n|sn|null|undefined)$/i;
  return basura.test(s) ? "" : s;
};
const onlyDigits = (v) => (v || "").replace(/\D+/g, "");

const norm = (s) =>
  (s || "")
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");

const getNombreEmpresa = (c) =>
  c?.empresa || c?.nombre || c?.razonSocial || c?.Nombre || "";

const getDireccionFields = (c) => ({
  calle: clean(c?.calle ?? c?.direccion?.calle),
  numeroExt: clean(
    c?.numeroExt ??
      c?.noExterior ??
      c?.numeroExterior ??
      c?.direccion?.numeroExt
  ),
  numeroInt: clean(
    c?.numeroInt ??
      c?.noInterior ??
      c?.numeroInterior ??
      c?.direccion?.numeroInt
  ),
  colonia: clean(c?.colonia ?? c?.direccion?.colonia),
  ciudad: clean(c?.ciudad ?? c?.direccion?.ciudad),
  estado: clean(c?.estado ?? c?.direccion?.estado),
  codigoPostal: onlyDigits(
    String(c?.codigoPostal ?? c?.cp ?? c?.direccion?.codigoPostal ?? "")
  ),
});

const direccionScore = (d) =>
  (d.calle ? 1 : 0) +
  (d.numeroExt ? 1 : 0) +
  (d.colonia ? 1 : 0) +
  (d.ciudad ? 1 : 0) +
  (d.estado ? 1 : 0) +
  (d.codigoPostal ? 1 : 0);

const makeKey = (f) =>
  [
    norm(
      `${f.calle || ""} ${f.numeroExt || ""}${
        f.numeroInt ? " Int " + f.numeroInt : ""
      }`
    ),
    norm(f.colonia || ""),
    norm(f.ciudad || ""),
    norm(f.estado || ""),
    f.codigoPostal || "",
  ].join("|");

const ResumenCotizacionV2 = ({
  cotizacion,
  isOpen,
  onClose,
  clientes,
  setCotizaciones,
  onClonar,
  cotizaciones,
}) => {
  const [showOptions, setShowOptions] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [showSummary, setShowSummary] = useState(true);
  const [pdfVisible, setPdfVisible] = useState(false);
  const [pdfBlobUrl, setPdfBlobUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showAdjuntosModal, setShowAdjuntosModal] = useState(false);
  const [adjuntos, setAdjuntos] = useState([]);
  const [hoverBack, setHoverBack] = useState(false);

  // respaldo: si el cliente no viene en props.clientes, se carga por Firestore
  const [clienteDeFS, setClienteDeFS] = useState(null);

  const navigate = useNavigate();
  const { formatDate } = useFunctionsPrevia();

  const handleConvertirOrden = () => {
    navigate("/orden-de-compra", {
      state: { cotizacion, convertirEnOrden: true },
    });
  };

  useEffect(() => {
    if (showAdjuntosModal && cotizacion?.archivos)
      setAdjuntos(cotizacion.archivos);
  }, [cotizacion, showAdjuntosModal]);

  // Cargar cliente por ID si no está en props.clientes
  useEffect(() => {
    const id = cotizacion?.cliente || cotizacion?.clienteId;
    if (!id) {
      setClienteDeFS(null);
      return;
    }
    const enProp = (clientes || []).find(
      (c) => c.id === id || c.__docId === id
    );
    if (enProp) {
      setClienteDeFS(enProp);
      return;
    }
    (async () => {
      try {
        const snap = await getDoc(doc(db, "clientes", id));
        setClienteDeFS(snap.exists() ? { id: snap.id, ...snap.data() } : null);
      } catch (e) {
        console.error("No pude leer el cliente por id:", e);
        setClienteDeFS(null);
      }
    })();
  }, [cotizacion?.cliente, cotizacion?.clienteId, clientes]);

  const handleDeleteArchivo = async (archivo) => {
    const result = await Swal.fire({
      title: "¿Estás seguro?",
      text: `Estás a punto de eliminar el archivo "${archivo.nombre}". Esta acción no se puede deshacer.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    });
    if (result.isConfirmed) {
      try {
        const fileRef = ref(storage, archivo.url);
        await deleteObject(fileRef);
        const cotizacionRef = doc(db, "cotizaciones", cotizacion.id);
        await updateDoc(cotizacionRef, {
          archivos: cotizacion.archivos.filter((a) => a.url !== archivo.url),
        });
        setAdjuntos((prev) => prev.filter((a) => a.url !== archivo.url));
        if (typeof setCotizaciones === "function") {
          setCotizaciones((prev) =>
            prev.map((c) =>
              c.id === cotizacion.id
                ? {
                    ...c,
                    archivos: c.archivos.filter((a) => a.url !== archivo.url),
                  }
                : c
            )
          );
        }
        Swal.fire({
          icon: "success",
          title: "Archivo eliminado",
          text: `El archivo "${archivo.nombre}" ha sido eliminado correctamente.`,
          timer: 1500,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error("Error al eliminar el archivo:", error);
        Swal.fire({
          icon: "error",
          title: "Error al eliminar",
          text: "Hubo un problema al eliminar el archivo. Por favor, intenta nuevamente.",
        });
      }
    }
  };

  useEffect(() => {
    if (!isOpen && onClose) onClose();
  }, [isOpen, onClose]);

  const memoizedPdfDocument = useMemo(() => {
    if (!cotizacion || !cotizacion.productosSeleccionados?.length) return null;

    const getClienteCanonicoPorNombre = (nombre, lista = []) => {
      const objetivo = norm(nombre);
      const cand = (lista || []).filter(
        (c) => norm(getNombreEmpresa(c)) === objetivo
      );
      if (!cand.length) return null;

      const marcado = cand.find(
        (c) => c.canonico || c.principal || c.preferido
      );
      if (marcado) return marcado;

      const ordenados = cand
        .map((c) => ({ c, f: getDireccionFields(c) }))
        .sort((a, b) => {
          const sa = direccionScore(a.f);
          const sb = direccionScore(b.f);
          if (sa !== sb) return sb - sa;
          const ka = makeKey(a.f);
          const kb = makeKey(b.f);
          return ka.localeCompare(kb);
        });

      return ordenados[0]?.c || null;
    };

    const ADDRESS_OVERRIDES = {
      "productos maver sa de cv": {
        ciudad: "Guadalajara",
        estado: "Jalisco",
        codigoPostal: "44490",
      },
    };
    const applyOverride = (fields, nombre) => {
      const ov = ADDRESS_OVERRIDES[norm(nombre)];
      return ov
        ? {
            ...fields,
            ...Object.fromEntries(
              Object.entries(ov).map(([k, v]) => [k, clean(v)])
            ),
          }
        : fields;
    };

    const cliById =
      getClienteDeCotizacion(cotizacion, clientes) || clienteDeFS || {};
    const nombreEmpresa =
      cotizacion?.nombreCliente || getNombreEmpresa(cliById);
    const universo = [...(clientes || []), cliById].filter(Boolean);
    const clienteCanonico =
      getClienteCanonicoPorNombre(nombreEmpresa, universo) || cliById;

    let finalFields = getDireccionFields(clienteCanonico || {});
    finalFields = applyOverride(finalFields, nombreEmpresa);

    const {
      calle,
      numeroExt,
      numeroInt,
      colonia,
      ciudad,
      estado,
      codigoPostal,
    } = finalFields;

    const subtotal = cotizacion.productosSeleccionados.reduce((acc, p) => {
      const precioBruto = (p.tarifa || 0) * (p.cantidad || 0);
      let desc = 0;
      if (p.tipoDescuento === "%")
        desc = precioBruto * ((p.descuento || 0) / 100);
      else if (p.tipoDescuento === "$") desc = p.descuento || 0;
      return acc + (precioBruto - desc);
    }, 0);

    const descuentoPorcentaje = cotizacion.descuento || 0;
    const descuentoAplicado = subtotal * (descuentoPorcentaje / 100);
    const subtotalConDescuento = subtotal - descuentoAplicado;
    const ivaTotal = subtotalConDescuento * 0.16;
    const total = subtotalConDescuento + ivaTotal;

    const divisa = (cotizacion.divisa || "MXN").toUpperCase();
    const monedaPalabra = divisa === "USD" ? "DÓLARES" : "PESOS";
    const totalEnLetras = montoALetras(total, monedaPalabra, divisa);

    const linea1Parts = [];
    if (calle) {
      let s = calle;
      if (numeroExt) s += ` ${numeroExt}`;
      if (numeroInt) s += ` Int. ${numeroInt}`;
      linea1Parts.push(s);
    }
    if (colonia) linea1Parts.push(colonia);

    const linea1 = linea1Parts.join(", ");
    const linea2 = [ciudad, estado].filter(Boolean).join(", ");

    const hasLinea1 = !!linea1;
    const hasLinea2 = !!linea2;
    const hasCP = !!codigoPostal;

    return (
      <Document>
        {/* Página en horizontal */}
        <Page size="A4" orientation="landscape" style={styles.page}>
          {/* === Encabezado nuevo === */}
          <View style={styles.headerRow}>
            <View style={styles.brandLeft}>
              <Image src="/img/logo-iciamex2.png" style={styles.brandLogo} />
            </View>

            {/* Dirección de la empresa en el header (a la derecha del logo) */}
            <View style={styles.headerAddress}>
              <Text style={styles.headerCompany}>
                UNIFICACION PARA LA AUTOMATIZACION SA DE CV
              </Text>
              <Text style={styles.headerAddressLine}>
                LIC. RAMIRO HERNÁNDEZ 448, COL. LAS PINTITAS,
              </Text>
              <Text style={styles.headerAddressLine}>
                EL SALTO, JAL. C.P. 45693
              </Text>
              <Text style={styles.headerAddressLine}>RFC: UAU151222IT1</Text>
            </View>
          </View>

          <View style={styles.topDividerBlue} />

          <View style={styles.infoContainer}>
            <View style={{ width: "100%" }}>
              {/* === Cliente (izquierda) + Cotización / # (derecha) === */}
              <View style={styles.clientAndFolioRow} wrap={false}>
                {/* IZQUIERDA: datos del cliente */}
                <View style={{ flex: 1 }}>
                  {(cotizacion?.nombreCliente ||
                    cotizacion?.atencion ||
                    cotizacion?.area ||
                    cotizacion?.planta ||
                    cotizacion?.asunto) && (
                    <View style={styles.clientBlock}>
                      {cotizacion?.nombreCliente && (
                        <View
                          style={[
                            styles.clientLine,
                            {
                              flexDirection: "row",
                              alignItems: "flex-start",
                              marginBottom: 8,
                            },
                          ]}
                        >
                          <Text style={[styles.clientLabel]}>Cliente: </Text>
                          <Text style={[styles.clientValue]}>
                            {cotizacion.nombreCliente ||
                              getNombreEmpresa(clienteCanonico)}
                          </Text>
                        </View>
                      )}

                      {cotizacion?.atencion && (
                        <View
                          style={[
                            styles.clientLine,
                            { flexDirection: "row", alignItems: "flex-start" },
                          ]}
                        >
                          <Text
                            style={[styles.clientLabel, { fontWeight: "bold" }]}
                          >
                            Atención:{" "}
                          </Text>
                          <Text
                            style={[
                              styles.clientValue,
                              { fontWeight: "normal" },
                            ]}
                          >
                            {cotizacion.atencion}
                          </Text>
                        </View>
                      )}

                      {cotizacion?.area && (
                        <View
                          style={[
                            styles.clientLine,
                            { flexDirection: "row", alignItems: "flex-start" },
                          ]}
                        >
                          <Text
                            style={[styles.clientLabel, { fontWeight: "bold" }]}
                          >
                            Área:{" "}
                          </Text>
                          <Text
                            style={[
                              styles.clientValue,
                              { fontWeight: "normal" },
                            ]}
                          >
                            {cotizacion.area}
                          </Text>
                        </View>
                      )}

                      {cotizacion?.planta && (
                        <View
                          style={[
                            styles.clientLine,
                            { flexDirection: "row", alignItems: "flex-start" },
                          ]}
                        >
                          <Text
                            style={[styles.clientLabel, { fontWeight: "bold" }]}
                          >
                            Planta:{" "}
                          </Text>
                          <Text
                            style={[
                              styles.clientValue,
                              { fontWeight: "normal" },
                            ]}
                          >
                            {cotizacion.planta}
                          </Text>
                        </View>
                      )}

                      {cotizacion?.asunto && (
                        <View
                          style={[
                            styles.clientLine,
                            { flexDirection: "row", alignItems: "flex-start" },
                          ]}
                        >
                          <Text
                            style={[styles.clientLabel, { fontWeight: "bold" }]}
                          >
                            Asunto:{" "}
                          </Text>
                          <Text
                            style={[
                              styles.clientValue,
                              { fontWeight: "normal" },
                            ]}
                          >
                            {cotizacion.asunto}
                          </Text>
                        </View>
                      )}
                    </View>
                  )}
                </View>

                {/* DERECHA: COTIZACIÓN + FOLIO */}
                <View style={styles.folioRightInline}>
                  <Text style={styles.titleCotizacion}>COTIZACIÓN</Text>
                  <View style={styles.folioBadge}>
                    <Text style={styles.folioText}>
                      #
                      {(cotizacion.numeroCotizacion || "")
                        .toString()
                        .toUpperCase()}
                    </Text>
                  </View>
                </View>
              </View>

              {/* === Tarjetas grises (FECHA, VENCIMIENTO, etc.) === */}
              {(() => {
                const items = [];
                if (cotizacion?.fechaCotizacion)
                  items.push({
                    k: "fecha",
                    label: "FECHA",
                    value: formatDate(cotizacion.fechaCotizacion),
                  });
                if (cotizacion?.fechaVencimiento)
                  items.push({
                    k: "vencimiento",
                    label: "VENCIMIENTO",
                    value: formatDate(cotizacion.fechaVencimiento),
                  });
                if (cotizacion?.divisa)
                  items.push({
                    k: "divisa",
                    label: "DIVISA",
                    value: (cotizacion.divisa || "MXN").toUpperCase(),
                  });
                if (cotizacion?.incoterm)
                  items.push({
                    k: "incoterm",
                    label: "INCOTERM",
                    value: (cotizacion.incoterm || "").toUpperCase(),
                  });
                if (cotizacion?.vendedorNombre)
                  items.push({
                    k: "vendedor",
                    label: "VENDEDOR",
                    value: (cotizacion.vendedorNombre || "").toUpperCase(),
                  });

                return items.length ? (
                  <View style={styles.metaRow} wrap={false}>
                    {items.map((it, idx) => (
                      <View
                        key={it.k}
                        style={[
                          styles.metaCell,
                          idx > 0 && styles.metaCellWithDivider,
                        ]}
                      >
                        <Text style={styles.metaLabel}>{it.label}:</Text>
                        <Text style={styles.metaValue}>{it.value}</Text>
                      </View>
                    ))}
                  </View>
                ) : null;
              })()}

              {hasLinea1 || hasLinea2 || hasCP ? null : null}
            </View>
          </View>

          {/* === TABLA === */}
          <View style={styles.table}>
            {/* ENCABEZADO (celdas View con borde completo) */}
            <View style={styles.tableRowHeader}>
              <View style={[styles.thCell, styles.colNum]}>
                <Text style={styles.thText}>#</Text>
              </View>
              <View style={[styles.thCell, styles.colDesc]}>
                <Text style={styles.thText}>DESCRIPCIÓN</Text>
              </View>
              <View style={[styles.thCell, styles.colModel]}>
                <Text style={styles.thText}>MODELO / PARTE</Text>
              </View>
              <View style={[styles.thCell, styles.colQty]}>
                <Text style={styles.thText}>CANT.</Text>
              </View>
              <View style={[styles.thCell, styles.colPrice]}>
                <Text style={styles.thText}>PRECIO</Text>
              </View>
              <View style={[styles.thCell, styles.colSub, styles.lastCol]}>
                <Text style={styles.thText}>SUBTOTAL</Text>
              </View>
            </View>

            {/* CUERPO */}
            {cotizacion.productosSeleccionados.map((producto, index) => {
              const raw = String(
                producto.descripcion || producto.nombre || ""
              ).replace(/\r/g, "");
              const hasTitulo = !!(
                producto.titulo && String(producto.titulo).trim()
              );

              const titulo = hasTitulo
                ? String(producto.titulo).trim()
                : (raw.split("\n")[0] || "").trim();

              const extra = hasTitulo
                ? raw
                : raw.split("\n").slice(1).join("\n");

              return (
                <View
                  key={index}
                  style={[styles.tr, index % 2 === 1 && styles.trAlt]}
                >
                  <Text style={[styles.td, styles.colNum, styles.center]}>
                    {index + 1}
                  </Text>

                  <View style={[styles.tdDesc, styles.colDesc]}>
                    {!!titulo && <Text style={styles.descTitle}>{titulo}</Text>}
                    {!!extra && <Text style={styles.descExtra}>{extra}</Text>}
                  </View>

                  <Text style={[styles.td, styles.colModel, styles.center]}>
                    {producto.modelo || producto.numeroDeParteCliente || "N/A"}
                  </Text>

                  <Text style={[styles.td, styles.colQty, styles.center]}>
                    {producto.cantidad}
                  </Text>

                  <Text style={[styles.td, styles.colPrice, styles.center]}>
                    {parseFloat(producto.tarifa || 0)
                      .toFixed(2)
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </Text>

                  <Text
                    style={[
                      styles.td,
                      styles.colSub,
                      styles.center,
                      styles.lastCol,
                    ]}
                  >
                    {parseFloat(producto.importe || 0)
                      .toFixed(2)
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </Text>
                </View>
              );
            })}

            {/* Totales */}
            <View style={styles.footerBlock} wrap={false}>
              <View style={[styles.footerRight, { alignSelf: "flex-end" }]}>
                {/* SUBTOTAL */}
                <View style={[styles.footerRow, styles.footerRowGray]}>
                  <View style={styles.footerLabelContainer}>
                    <Text style={[styles.footerLabel, { fontWeight: "bold" }]}>
                      SUBTOTAL
                    </Text>
                  </View>
                  <View style={styles.footerValueContainer}>
                    <Text style={styles.footerValue}>
                      $
                      {subtotal
                        .toFixed(2)
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    </Text>
                  </View>
                </View>

                {/* (Opcional) Descuento */}
                {descuentoAplicado > 0 && (
                  <>
                    <View style={[styles.footerRow, styles.footerRowGray]}>
                      <View style={styles.footerLabelContainer}>
                        <Text style={styles.footerLabel}>
                          DESCUENTO ({descuentoPorcentaje}%)
                        </Text>
                      </View>
                      <View style={styles.footerValueContainer}>
                        <Text style={styles.footerValue}>
                          -$
                          {descuentoAplicado
                            .toFixed(2)
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        </Text>
                      </View>
                    </View>

                    <View style={[styles.footerRow, styles.footerRowGray]}>
                      <View style={styles.footerLabelContainer}>
                        <Text style={styles.footerLabel}>RESTANTE</Text>
                      </View>
                      <View style={styles.footerValueContainer}>
                        <Text style={styles.footerValue}>
                          $
                          {subtotalConDescuento
                            .toFixed(2)
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        </Text>
                      </View>
                    </View>
                  </>
                )}

                {/* IVA */}
                <View style={[styles.footerRow, styles.footerRowGray]}>
                  <View style={styles.footerLabelContainer}>
                    <Text style={[styles.footerLabel, { fontWeight: "bold" }]}>
                      IVA (16%)
                    </Text>
                  </View>
                  <View style={styles.footerValueContainer}>
                    <Text style={styles.footerValue}>
                      $
                      {ivaTotal
                        .toFixed(2)
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    </Text>
                  </View>
                </View>

                {/* TOTAL */}
                <View style={[styles.footerRow, styles.footerRowBlue]}>
                  <View style={styles.footerLabelContainer}>
                    <Text style={[styles.footerLabel, styles.footerLabelBlue]}>
                      TOTAL {divisa}
                    </Text>
                  </View>
                  <View style={styles.footerValueContainer}>
                    <Text style={[styles.footerValue, styles.footerValueBlue]}>
                      ${total.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    </Text>
                  </View>
                </View>

                <View style={styles.montoGroup}>
                  <Text style={styles.montoEnLetrasLabel}>
                    IMPORTE TOTAL CON LETRA
                  </Text>
                  <Text style={styles.montoEnLetras}>{totalEnLetras}</Text>
                </View>
              </View>
            </View>

            {/* === BLOQUE 2 (nueva página): Costos / Tiempos / Condiciones / Notas === */}
            <View break>
              <View style={styles.sectionBlock}>
                <Text style={styles.sectionTitle}>
                  Costos en Moneda Nacional
                </Text>
                <Text style={styles.paragraph}>
                  Para las cotizaciones elaboradas en dólares, el tipo de cambio
                  a tomar será el especificado en el Diario Oficial de la
                  Federación el día de la facturación y/o pago.
                </Text>

                <Text style={styles.sectionHeading}>TIEMPO DE ENTREGA:</Text>
                <Text style={styles.sectionItem}>
                  {cotizacion.tiempoEntrega &&
                  String(cotizacion.tiempoEntrega).trim()
                    ? cotizacion.tiempoEntrega
                    : "—"}
                </Text>

                <Text style={styles.sectionHeading}>CONDICIONES DE PAGO:</Text>
                {cotizacion.condicionesPago &&
                String(cotizacion.condicionesPago).trim() ? (
                  String(cotizacion.condicionesPago)
                    .replace(/\r/g, "")
                    .split(/\n+/)
                    .filter(Boolean)
                    .map((linea, i) => (
                      <Text key={i} style={styles.sectionItem}>
                        {linea}
                      </Text>
                    ))
                ) : (
                  <Text style={styles.sectionItem}>—</Text>
                )}
              </View>
            </View>

            {/* === BLOQUE 3 (nueva página): CONDICIONES IMPORTANTES === */}
            <View break>
              <View style={styles.legalSection} break>
                <Text style={styles.legalTitle}>CONDICIONES IMPORTANTES.</Text>

                <Text style={styles.legalParagraph}>
                  Las cotizaciones, incluyendo imágenes y precios, son de
                  carácter informativo, y podrán variar según el producto y la
                  fecha del pedido. En el caso de fabricación de equipos, el
                  diseño final será enviado una ves que se haya confirmado orden
                  de compra o anticipo.
                </Text>

                <Text style={styles.legalItem}>
                  Favor de confirmar existencias antes de realizar pedido.
                </Text>
                <Text style={styles.legalItem}>
                  Precios sujetos a cambio sin previo aviso.
                </Text>
                <Text style={styles.legalItem}>
                  En algunos pedidos requiere 50% de anticipo para empezar la
                  fabricación del proyecto.
                </Text>

                <Text style={styles.legalHeading}>
                  TODA CANCELACIÓN O DEVOLUCIÓN GENERA UN CARGO.
                </Text>
                <Text style={styles.legalParagraph}>
                  Se aplicará un 50% del valor del producto a las cancelaciones
                  solicitadas, y según la etapa del proyecto, pero estará
                  condicionado a la aprobación de nuestra área de Ingeniería y
                  Mantenimiento. Este valor es debido a que los equipos son
                  fabricados especialmente y de acuerdo a las especificaciones
                  del cliente.
                </Text>

                <Text style={styles.legalHeading}>ENVÍOS.</Text>
                <Text style={styles.legalParagraph}>
                  Todos los pedidos que requieran del servicio de paquetería se
                  enviarán a la dirección de facturación si el cliente no
                  especifica por escrito la dirección del envío. El tiempo de
                  entrega y costo dependerá de la paquetería elegida por el
                  cliente.
                </Text>
                <Text style={styles.legalParagraph}>
                  La capacitación o asesoría fuera de nuestras instalaciones
                  generará un costo adicional, así como las visitas para
                  cualquier servicio o mantenimiento solicitado, agregándose al
                  mismo un cargo por transporte, hospedaje y viáticos, y estarán
                  sujetas a programación.
                </Text>

                <Text style={styles.legalHeading}>GARANTÍA.</Text>
                <Text style={styles.legalParagraph}>
                  Los equipos y refacciones nuevas cuentan con 1 año de
                  garantía, ya sea por defectos de manufactura o de los
                  materiales, excepto en las partes eléctricas y en aquellos que
                  por mal uso se deterioren. Todas las garantías se validarán en
                  nuestro domicilio, a excepción de aquellas que se soliciten en
                  otra ubicación, siempre y cuando haya sido cubierto al 100% el
                  costo que este genere. Nos reservamos el derecho de aplicar la
                  garantía si el equipo ha sido utilizado de forma inadecuada o
                  detecta intentos de reparación por personas no autorizadas.
                </Text>

                <View style={{ marginTop: 8 }}>
                  <Text style={styles.legalItem}>
                    Para cualquier duda, comunicarse al teléfono:
                  </Text>
                  <Text style={styles.legalItem}>
                    33 3619 2439 ó al correo contacto@iciamex.com
                  </Text>
                </View>
              </View>
            </View>
          </View>

          {/* Footer fijo con número de página */}
          <View
            fixed
            style={{
              position: "absolute",
              bottom: 10,
              left: 20,
              right: 30,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Text
              style={{
                fontSize: 10,
                textAlign: "left",
                marginLeft: 10,
                color: "#999999",
              }}
            >
              UNIFICACION PARA LA AUTOMATIZACION SA DE CV
            </Text>
            <Text
              style={styles.numeroDePagina}
              render={({ pageNumber }) => `${pageNumber}`}
            />
          </View>
        </Page>
      </Document>
    );
  }, [cotizacion, clientes, clienteDeFS, formatDate]);

  useEffect(() => {
    let isMounted = true;
    let url;
    const generar = async () => {
      if (!memoizedPdfDocument) {
        setPdfBlobUrl(null);
        setLoading(false);
        return;
      }
      setLoading(true);
      try {
        const blob = await pdf(memoizedPdfDocument).toBlob();
        if (!isMounted) return;
        url = URL.createObjectURL(blob);
        setPdfBlobUrl(url);
      } catch (err) {
        console.error("Error generando PDF:", err);
        if (isMounted) setPdfBlobUrl(null);
      } finally {
        if (isMounted) setLoading(false);
      }
    };
    generar();
    return () => {
      isMounted = false;
      if (url) URL.revokeObjectURL(url);
    };
  }, [memoizedPdfDocument]);

  const navigateToClone = async () => {
    try {
      const docRef = doc(db, "configuracion", "numeroCotizacion");
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        const { prefijo = "IC-", siguienteNumero = "1" } = data;
        const posibleNumero = `${prefijo}${siguienteNumero}`;

        const clon = {
          ...cotizacion,
          fechaCotizacion: new Date(),
          numeroCotizacion: posibleNumero,
          resumenVersion: 2,
        };

        delete clon.id;
        if (typeof onClonar === "function") onClonar(clon);
        if (onClose) onClose();
      } else {
        console.error("No se encontró la config de numeroCotizacion");
      }
    } catch (error) {
      console.error("Error al clonar la cotización:", error);
      Swal.fire({
        icon: "error",
        title: "Error al clonar",
        text: "Hubo un problema al clonar la cotización. Intenta nuevamente.",
      });
    }
  };

  const handleEliminar = async () => {
    const result = await Swal.fire({
      title: `¿Seguro que quieres eliminar la cotización "${cotizacion.numeroCotizacion}"?`,
      text: "Esta acción no se puede deshacer",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    });
    if (result.isConfirmed) {
      if (onClose) onClose();
      try {
        await deleteDoc(doc(db, "cotizaciones", cotizacion.id));
        if (setCotizaciones) {
          setCotizaciones((prev) => prev.filter((c) => c.id !== cotizacion.id));
        }
        await Swal.fire({
          icon: "success",
          title: "Eliminado",
          text: `La cotización "${cotizacion.numeroCotizacion}" ha sido eliminada correctamente.`,
          timer: 1500,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error("Error al eliminar la cotización:", error);
        Swal.fire({
          icon: "error",
          title: "Error al eliminar",
          text: "No se pudo eliminar la cotización. Intenta de nuevo.",
        });
      }
    }
  };

  const handlePrint = () => setPdfVisible(true);
  const handleClosePDF = () => setPdfVisible(false);

  const handleEdit = () => {
    setEditMode(true);
    setShowSummary(false);
  };

  const closeModal = () => {
    setEditMode(false);
    setShowSummary(true);
    onClose();
  };

  const obtenerIconoArchivo = (nombreArchivo) => {
    const extension = nombreArchivo.split(".").pop().toLowerCase();
    switch (extension) {
      case "xls":
      case "xlsx":
      case "csv":
        return { icon: "bi-file-earmark-excel", color: "green" };
      case "doc":
      case "docx":
        return { icon: "bi-file-earmark-word", color: "blue" };
      case "pdf":
        return { icon: "bi-file-earmark-pdf", color: "red" };
      case "jpg":
      case "jpeg":
      case "png":
      case "svg":
        return { icon: "bi-image", color: "blue" };
      default:
        return { icon: "bi-file-earmark", color: "gray" };
    }
  };

  if (editMode) {
    return (
      <EditarCotizacionForm
        cotizacion={cotizacion}
        clientes={clientes}
        productos={cotizacion && cotizacion.productosSeleccionados}
        setCotizaciones={setCotizaciones}
        cotizaciones={cotizaciones}
        onClose={closeModal}
      />
    );
  }

  if (pdfVisible) {
    return (
      <div style={styles.pdfContainer}>
        <button
          className="cerrar-button"
          style={styles.closeButton}
          onClick={handleClosePDF}
        >
          <i className="bi bi-x-lg"></i>
        </button>
        <PDFViewer className="pdf-viewer" style={styles.pdfViewer}>
          {memoizedPdfDocument}
        </PDFViewer>
      </div>
    );
  }

  if (showSummary && cotizacion && cotizacion.productosSeleccionados) {
    return (
      <div className="resumen-cotizacion-container">
        {/* Header: izquierda = Regresar / derecha = botones azules */}
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            gap: 10,
            marginBottom: 10,
            flexWrap: "wrap",
            position: "relative",
            top: "2px",
          }}
        >
          <button
            onClick={onClose}
            title="Regresar a la tabla"
            onMouseEnter={() => setHoverBack(true)}
            onMouseLeave={() => setHoverBack(false)}
            style={{
              ...backBtnStyle,
              position: "static",
              marginTop: "2px",
              background: hoverBack ? "#e9ecef" : backBtnStyle.background,
              border: "1px solid #d0d7de",
              borderRadius: 8,
            }}
          >
            <i className="bi bi-arrow-left-short" style={backBtnIconStyle}></i>
            <span>Regresar a la tabla</span>
          </button>

          <div className="resumen-cotizacion-actions">
            <div
              className="dropdown"
              onMouseEnter={() => setShowOptions(true)}
              onMouseLeave={() => setShowOptions(false)}
            >
              <button className="dropbtn">
                <i className="bi bi-printer iconResumen"></i> Imprimir / PDF
              </button>
              {showOptions && (
                <div className="dropdown-content">
                  <button onClick={handlePrint}>
                    <i
                      className="bi bi-file-earmark-text"
                      style={{ marginRight: "10px" }}
                    ></i>
                    Imprimir
                  </button>
                  <a
                    href={pdfBlobUrl || "#"}
                    download={`${cotizacion.numeroCotizacion || "sin_numero"}_${
                      cotizacion.asunto || "sin_asunto"
                    }.pdf`}
                    style={{ textDecoration: "none" }}
                    onClick={(e) => {
                      if (!pdfBlobUrl) e.preventDefault();
                    }}
                  >
                    <button>
                      <i
                        className="bi bi-download"
                        style={{ marginRight: "10px" }}
                      ></i>
                      Descargar PDF
                    </button>
                  </a>
                </div>
              )}
            </div>

            <button>
              <i className="bi bi-envelope-fill iconResumen"></i> Correo
            </button>

            <button onClick={handleEdit}>
              <i className="bi bi-pencil-fill iconResumen"></i> Editar
            </button>

            <div
              className="dropdown"
              onMouseEnter={() => setShowOptions(true)}
              onMouseLeave={() => setShowOptions(false)}
            >
              <button className="dropbtn">
                <i className="bi bi-file-earmark-text iconResumen"></i>{" "}
                Convertir en
              </button>
              {showOptions && (
                <div className="dropdown-content">
                  <button onClick={handleConvertirOrden}>
                    <i
                      className="bi bi-file-text"
                      style={{ marginRight: "10px" }}
                    ></i>
                    Pedido
                  </button>
                  <button>
                    <i
                      className="bi bi-receipt"
                      style={{ marginRight: "10px" }}
                    ></i>
                    Factura
                  </button>
                </div>
              )}
            </div>

            <div
              className="dropdown"
              onMouseEnter={() => setShowOptions(true)}
              onMouseLeave={() => setShowOptions(false)}
            >
              <button className="dropbtn">
                <i
                  className="bi bi-three-dots-vertical iconResumen"
                  style={{ marginRight: 0 }}
                ></i>
              </button>
              {showOptions && (
                <div className="dropdown-content">
                  <button onClick={handleEliminar}>
                    <i
                      className="bi bi-trash"
                      style={{ marginRight: "10px" }}
                    ></i>
                    Eliminar
                  </button>
                  <button onClick={navigateToClone}>
                    <i
                      className="bi bi-files"
                      style={{ marginRight: "10px" }}
                    ></i>
                    Clonar
                  </button>
                </div>
              )}
            </div>

            {cotizacion.archivos && cotizacion.archivos.length > 0 && (
              <button onClick={() => setShowAdjuntosModal(true)}>
                <i className="bi bi-paperclip iconResumen"></i> Archivos
                Adjuntos
              </button>
            )}
          </div>
        </div>

        <Modal
          isOpen={showAdjuntosModal}
          onRequestClose={() => setShowAdjuntosModal(false)}
          contentLabel="Archivos Adjuntos"
          style={{
            content: {
              top: "50%",
              left: "50%",
              right: "auto",
              bottom: "auto",
              marginRight: "-50%",
              transform: "translate(-50%, -50%)",
              width: "35%",
              maxHeight: "80vh",
              overflowY: "auto",
              padding: "20px",
              borderRadius: "10px",
            },
            overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
          }}
        >
          <button
            onClick={() => setShowAdjuntosModal(false)}
            className="modal-close"
            title="Cerrar"
          >
            <i className="bi bi-x-lg"></i>
          </button>

          <h3
            style={{
              marginBottom: "20px",
              color: "#000",
              fontFamily: "Roboto, sans-serif",
            }}
          >
            Archivos Adjuntos
          </h3>

          <ul style={{ listStyle: "none", padding: 0 }}>
            {adjuntos.map((archivo, index) => {
              const { icon, color } = obtenerIconoArchivo(archivo.nombre);
              return (
                <li
                  key={index}
                  style={{
                    marginBottom: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "10px",
                    border: "1px solid #ddd",
                    borderRadius: "5px",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <i
                      className={`bi ${icon}`}
                      style={{ color, fontSize: "1.5rem", marginRight: 10 }}
                    />
                    <a
                      href={archivo.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        textDecoration: "none",
                        color: "#000",
                        fontFamily: "Roboto, sans-serif",
                      }}
                    >
                      {archivo.nombre}
                    </a>
                  </div>

                  <div style={{ display: "flex", alignItems: "center" }}>
                    <a href={archivo.url} download={archivo.nombre}>
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          const link = document.createElement("a");
                          link.href = archivo.url;
                          link.target = "_blank";
                          link.rel = "noopener noreferrer";
                          link.download = archivo.nombre;
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                        }}
                        style={{
                          background: "none",
                          border: "none",
                          color: "#007bff",
                          cursor: "pointer",
                          fontSize: 20,
                        }}
                        title="Descargar archivo"
                      >
                        <i className="bi bi-download"></i>
                      </button>
                    </a>
                    <button
                      onClick={() => handleDeleteArchivo(archivo)}
                      style={{
                        background: "none",
                        border: "none",
                        color: "#dc3545",
                        cursor: "pointer",
                        marginRight: 10,
                        fontSize: 20,
                      }}
                      title="Eliminar archivo"
                    >
                      <i className="bi bi-trash"></i>
                    </button>
                  </div>
                </li>
              );
            })}
          </ul>
        </Modal>

        <div
          style={{
            height: "600px",
            width: "100%",
            marginTop: "-20px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {loading ? (
            <div className="loader2"></div>
          ) : (
            pdfBlobUrl && (
              <iframe
                src={`${pdfBlobUrl}#toolbar=0`}
                style={{ width: "100%", height: "100%" }}
                frameBorder="0"
                title="Vista previa del PDF"
              />
            )
          )}
        </div>
      </div>
    );
  }

  return null;
};

export default ResumenCotizacionV2;
